(() => {
  if (window.GRLCOMPLETELOOK) return;
  window.GRLCOMPLETELOOK = true;

  const rootFor = (element) => element?.closest('[data-grl-complete-look]');
  const checkedFor = (root) =>
    Array.from(root?.querySelectorAll('input[name="bundles"]:checked') || []);

  const updateCTA = (root) => {
    if (!root) return;

    const cta = root.querySelector('[data-grl-bundle-submit]');
    const label = root.querySelector('[data-grl-bundle-label]');
    const count = checkedFor(root).length;

    if (!cta) return;
    cta.hidden = count === 0;

    if (label && count > 0) {
      label.textContent = count === 1
        ? 'Add selected item + this look to cart'
        : `Add ${count} selected items + this look to cart`;
    }
  };

  const updateArrows = (root) => {
    if (!root) return;

    const track = root.querySelector('[data-grl-ctl-track]');
    const prev = root.querySelector('[data-grl-ctl-prev]');
    const next = root.querySelector('[data-grl-ctl-next]');
    if (!track || !prev || !next) return;

    const max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max;
  };

  const scrollStep = (track) => {
    const card = track?.querySelector('.grl-ctl__card');
    if (!card) return 260;

    const styles = getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || 0);
    return card.getBoundingClientRect().width + gap;
  };

  const initialize = (scope = document) => {
    const roots = scope.matches?.('[data-grl-complete-look]')
      ? [scope]
      : scope.querySelectorAll?.('[data-grl-complete-look]') || [];

    roots.forEach((root) => {
      updateCTA(root);
      requestAnimationFrame(() => updateArrows(root));
    });
  };

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-grl-ctl-prev], [data-grl-ctl-next]');

    if (arrow) {
      event.preventDefault();
      event.stopPropagation();

      const root = rootFor(arrow);
      const track = root?.querySelector('[data-grl-ctl-track]');
      if (!track) return;

      const direction = arrow.matches('[data-grl-ctl-prev]') ? -1 : 1;
      track.scrollBy({ left: direction * scrollStep(track), behavior: 'smooth' });
      return;
    }

    const cta = event.target.closest('[data-grl-bundle-submit]');
    if (!cta) return;

    event.preventDefault();
    const root = rootFor(cta);
    if (!root || checkedFor(root).length === 0) return;

    const formId = root.dataset.formId;
    const form = formId ? document.getElementById(formId) : null;
    form?.requestSubmit();
  }, true);

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-grl-complete-look] input[name="bundles"]')) return;
    updateCTA(rootFor(event.target));
  });

  document.addEventListener('scroll', (event) => {
    if (!event.target.matches?.('[data-grl-ctl-track]')) return;
    requestAnimationFrame(() => updateArrows(rootFor(event.target)));
  }, true);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) initialize(node);
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initialize();
      observer.observe(document.body, { childList: true, subtree: true });
    }, { once: true });
  } else {
    initialize();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
